import React from "react";
import { Link } from "react-router-dom";
import Seo from "../components/Seo";
import { Hero, Arrow } from "../components/Section";

export default function NotFound() {
  return (
    <>
      <Seo title="Page not found — Syni.ai" description="This page does not exist." path="/404" />
      <Hero label="404" title="This page does not exist." testId="not-found">
        <div style={{ marginTop: 32 }}>
          <Link to="/" className="link-arrow" data-testid="not-found-home-link">
            <Arrow /> Home
          </Link>
        </div>
      </Hero>
    </>
  );
}
